/* disable eslint */
import { setCurrentUser } from 'shared/utils/setCurrentUser/setCurrentUser'
import { getCollaboratorRole, getProductType } from './utils'

require('./init-global-components')

const ns = typeof window === 'undefined' ? global : window

ns.BookmarkletItemAddSuccessModal =
  require('./BookmarkletItemAddSuccessModal').default

ns.ReactRailsUJS = require('react_ujs')

ns.utils = {
  getCollaboratorRole,
  getProductType,
  setCurrentUser,
}
